<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Device Status
              </div>
              <q-btn
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                @click="handleRefresh()"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="filteredDeviceStatuses && !deviceStatusesLoading">
              <q-scroll-area style="height: calc(100vh - 220px) !important">
                <div class="photoGrid">
                  <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                  <div
                    class="q-pa-none"
                    v-for="(device, index) in filteredDeviceStatuses"
                    :key="`device_${index}`"
                  >
                    <q-card class="deviceStatusCard q-ma-none">
                      <q-card-section class="q-pa-none">
                        <div
                          style="
                            height: 100px;
                            width: 200px;
                            position: relative;
                          "
                          :class="{
                            'bg-primary': getTrapValue(device) != 0,
                            'bg-blue-grey': getTrapValue(device) == 0,
                          }"
                        >
                          <span
                            style="
                              position: absolute;
                              top: 50%;
                              transform: translateY(-50%);
                              text-align: center;
                              width: 100%;
                            "
                            class="text-white"
                            >{{
                              getTrapValue(device) == 0
                                ? "Un-Triggered"
                                : getTrapValue(device) == 1
                                ? "Trap 1 Triggered"
                                : getTrapValue(device) == 2
                                ? "Trap 2 Triggered"
                                : "Both Traps Triggered"
                            }}</span
                          >
                        </div>
                      </q-card-section>
                      <q-card-section class="q-pa-sm">
                        <div class="row">
                          <div class="col-12">
                            <b>Device:</b> {{ device.id }}
                          </div>
                          <div class="col-12">
                            <b>Updated:</b>
                            {{ device.lastMessageReceived | momentFromNow }}
                            <q-tooltip>
                              {{ device.lastMessageReceived | momentFormat }}
                            </q-tooltip>
                          </div>
                        </div>
                      </q-card-section>
                    </q-card>
                  </div>
                </div>
              </q-scroll-area>
            </div>
          </q-card-section>
          <q-card-section>
            <q-pagination
              color="accent"
              class="justify-center"
              v-model="currentPage"
              :max="Math.ceil(filteredDeviceStatuses.length / devicesPerPage)"
              :max-pages="6"
              direction-links
              boundary-links
            />
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="viewDetailsDialog" max-width="600px">
      <q-card
        class="deviceStatusDetails"
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 600px; height: 90vh"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Device {{ formData.id }}
            </div>
            <q-space />
            <q-btn
              color="accent2"
              round
              flat
              icon="mdi-close"
              @click="viewDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-scroll-area style="height: calc(90vh - 60px)">
          <q-card-section class="q-pa-none">
            <q-img
              contain
              :src="`https://flexi-comms-trigger-events${
                apiUrl == 'https://api.flexi-comms.com' ? '-live' : ''
              }.s3.ap-southeast-2.amazonaws.com/${formData.id}-deviceStatus.${
                formData.fileType
              }`"
            >
            </q-img>
          </q-card-section>
          <q-card-section>
            <div class="row">
              <div class="col-12 q-px-sm">
                <h6 class="q-my-none">Event ID</h6>
                <p>
                  {{ formData.id }}
                </p>
              </div>
              <div class="col-12 col-sm-6 q-px-sm">
                <h6 class="q-my-none">Server Time</h6>
                <p>
                  {{ formData.created_at | momentFormat }}
                </p>
              </div>
              <div v-if="!formData.rb_data" class="col-12 col-sm-6 q-px-sm">
                <h6 class="q-my-none">Device Time</h6>
                <p>
                  {{ formData.invalidDeviceTime | momentFormat }}
                </p>
              </div>
              <div v-if="formData.rb_data" class="col-12 col-sm-6 q-px-sm">
                <h6 class="q-my-none">Device Time</h6>
                <p>
                  {{
                    formData.rb_data == 1
                      ? "Trap 1 Triggered"
                      : formData.rb_data == 2
                      ? "Trap 2 Triggered"
                      : "Both Traps Triggered"
                  }}
                </p>
              </div>
              <div v-if="!formData.rb_data" class="col-12 col-sm-6 q-px-sm">
                <h6 class="q-my-none">Trigger Count</h6>
                <p>
                  {{ formData.triggers }}
                </p>
              </div>
              <div v-if="!formData.rb_data" class="col-12 col-sm-6 q-px-sm">
                <h6 class="q-my-none">Session Number</h6>
                <p>
                  {{ formData.sessions }}
                </p>
              </div>
              <div v-if="!formData.rb_data" class="col-12 q-px-sm">
                <h6 class="q-my-none">Meta Data</h6>
                <pre>
                {{ formData.metaData }}
              </pre
                >
              </div>
            </div>
          </q-card-section>
        </q-scroll-area>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";
  import moment from "moment";

  // import { Notify } from "quasar";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        deviceStatuses: "devices/deviceStatuses",
        deviceStatusesLoading: "devices/deviceStatusesLoading",
        apiUrl: "settings/apiUrl",
        siteSettings: "settings/siteSettings",
      }),
      // SpecializedDateRange
    },
    watch: {
      deviceStatuses: function () {
        this.filterDeviceStatuses();
      },
      search: function () {
        this.filterDeviceStatuses();
      },
      currentPage: function () {
        this.pagination();
      },
    },
    data: () => ({
      search: "",

      viewDetailsDialog: false,
      formData: null,

      dateRangeDialog: false,
      filteredDeviceStatuses: [],
      page: [],
      currentPage: 1,
      devicesPerPage: null,
    }),
    beforeCreate() {
      this.$store.dispatch("devices/loadAllDeviceStatuses");
    },
    mounted() {
      this.devicesPerPage = this.siteSettings.deviceStatusesPerPage;
      this.filterDeviceStatuses();
    },
    methods: {
      handleRefresh() {
        this.$store.dispatch("devices/loadAllDeviceStatuses");
      },
      filterDeviceStatuses() {
        let rows = JSON.parse(JSON.stringify(this.deviceStatuses));
        if (this.search) {
          rows = rows.filter((row) => {
            return row.id.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
          });
        }
        this.filteredDeviceStatuses = rows;
        this.pagination();
      },
      pagination() {
        let data = JSON.parse(JSON.stringify(this.filteredDeviceStatuses));
        this.page = data.splice(
          (this.currentPage - 1) * this.devicesPerPage,
          this.devicesPerPage
        );
        this.$store.dispatch(
          "settings/changeDeviceStatusesPerPage",
          this.devicesPerPage
        );
      },
      getTrapValue(device) {
        if (device.rb_data === null) {
          let trapData = JSON.parse(device.extendedData).find(
            (e) => e.traps
          ).traps;

          if (trapData[0] == 0 && trapData[1] == 0) {
            return 0;
          }
          if (trapData[0] == 1 && trapData[1] == 0) {
            return 1;
          }
          if (trapData[0] == 0 && trapData[1] == 1) {
            return 2;
          }
          return 3;
        } else {
          return device.rb_data;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  #depthCard:hover {
    background: #5cb3ff;
    color: white;
  }

  .deviceStatusCard {
    width: 200px;
    height: 160px;
  }

  .downloadButton {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }

  .photoGrid {
    padding: 10px;
    display: grid;
    grid-template-columns: repeat(auto-fill, 200px);
    grid-gap: 0.5rem;
    justify-content: space-around;
  }

  .deviceStatusDetails {
    h6 {
      color: $accent;
      font-size: 12pt;
      font-weight: bold;
    }
  }

  @media (max-width: 630px) {
    .deviceStatusCard {
      width: 42vw !important;
      height: 70vw !important;
    }
    .photoGrid {
      grid-template-columns: repeat(auto-fill, 42vw) !important;
    }
  }
</style>

<style>
</style>
